module.exports = __webpack_public_path__ + "img/Guaranty_Trust_Bank.1ede69ad.png";